// extracted by mini-css-extract-plugin
module.exports = {"zoomButtons":"SetPolygonZoom_zoomButtons__2bTek","cancel":"SetPolygonZoom_cancel__E0CrA"};